import React from 'react';
import { RowGroupInputsWrapper } from 'framework/ui/ui-builder';
import { ClearAfterUnmountWrapper, Checkbox, DateInput, useInputHelper } from 'framework/form';

const TargetHireDateInput = () => {
  const { getValue } = useInputHelper({ source: 'isAsap' });
  const isAsap = getValue();

  return (
    <RowGroupInputsWrapper
      isRequired
      wrapperLabel="Target hiring date"
      sxProps={{
        '& > div:first-of-type': {
          flexBasis: '25%',
          flexGrow: 1,
          maxWidth: '25%',
        },

        '& > div:not(:first-of-type)': {
          flexBasis: '75%',
          maxWidth: '75%',
        },
      }}
    >
      <Checkbox source="isAsap" defaultValue={false} label="Asap" />

      {isAsap ? null : (
        <ClearAfterUnmountWrapper>
          <DateInput source="targetHiringDate" />
        </ClearAfterUnmountWrapper>
      )}
    </RowGroupInputsWrapper>
  );
};

export default TargetHireDateInput;
